import React from 'react';
import Ubicaciones from './mapa/main'

export default class main extends React.Component {
    constructor() {
        super();
        this.state = {
        }
    }

    componentWillMount() {
        console.log("cafe haiti render")
    }

    render() {
        return (
            <div>
                <Ubicaciones />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/cafe-haiti/main.js